import type { GetStaticProps, GetStaticPaths, GetServerSideProps } from "next";
import { ApiService } from "services/server";
import ConferenceVideos from "views/ConferenceVideos/ConferenceVideos";
import {
  normalizeConference,
  normalizeHomeConferences,
} from "utils/normalizer";
import { REVALIDATE_TIME, TAG_TREES } from "utils/constants";
import { checkEmpty, is404 } from "utils/newFunction";
import { Formatter } from "utils/formatter";

function ConferenceVideosPage({ data }) {
  return <ConferenceVideos data={data} />;
}

// export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
//   const apiService = new ApiService(locale);

//   const entityId = params?.entityId;
//   const requests = [
//     apiService.getHomeConferenceList(), // 0
//   ];
//   if (entityId) requests.push(apiService.getContentByEntityId(entityId)); // 1

//   const response = await ApiService.multipleRequest(requests);
//   if (checkEmpty(...response)) {
//     throw new Error();
//   }
//   const target = response?.[1]?.[0];
//   const conference = normalizeConference(target) || null;
//   const breadcrumb = target?.breadcrumb || [];

//   breadcrumb[breadcrumb?.length - 1] = {
//     title: breadcrumb.at(-1)?.title || "",
//     link: conference?.link || "",
//   };
//   breadcrumb.push({ title: locale === "fa" ? "ویدیوها" : "Videos" });

//   return {
//     props: {
//       data: {
//         latestNews: response?.[0] || [],
//         conference,
//         conferences: normalizeHomeConferences(response[0], locale) || null,
//         changeLanguageLink: target?.changeLanguageLink?.value || "/conferences",
//         breadcrumb: breadcrumb || [],
//         metaTag: target?.metaTag || {},
//       },
//     },
//     revalidate: REVALIDATE_TIME,
//   };
// };

// export const getStaticPaths: GetStaticPaths = async () => {
//   return {
//     paths: [],
//     fallback: true,
//   };
// };
export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
}) => {
  const apiService = new ApiService(locale);
  try {
    const entityId = params?.entityId;

    if (Number.isNaN(+entityId) || Number.isNaN(+params.slug?.[0])) {
      return {
        notFound: true,
      };
    }

    const requests = [
      apiService.getHomeConferenceList(), // 0
      apiService.getConferenceById(entityId, { formatter: false }), // 1
    ];

    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}

    if (is404(response?.[1])) {
      return {
        notFound: true,
      };
    }

    const targetConference = Formatter.formatData({ data: response?.[1] })?.[0];

    if (
      !targetConference?.tagTrees?.find(
        (item) =>
          item?.name === TAG_TREES[locale?.toUpperCase() || "FA"]?.CONFERENCES
      )
    ) {
      return {
        notFound: true,
      };
    }
    const normalizedConference = normalizeConference(targetConference) || null;
    const breadcrumb = targetConference?.breadcrumb || [];

    const targetVideo = normalizedConference.videos.find(
      (item) => +item.id === +params.slug?.[0]
    );

    if (targetVideo) {
      if (targetVideo.slug && targetVideo.slug !== params.slug?.[1]) {
        return {
          redirect: {
            destination: `${
              locale === "en" ? "/en" : ""
            }/conferences/${entityId}/videos/${
              params.slug?.[0]
            }/${encodeURIComponent(targetVideo.slug)}`,
          },
        };
      }
    } else if (normalizedConference?.videos?.[0]) {
      return {
        redirect: {
          destination: `${
            locale === "en" ? "/en" : ""
          }/conferences/${entityId}/videos/${
            normalizedConference?.videos?.[0]?.id
          }/${encodeURIComponent(normalizedConference?.videos[0]?.slug)}`,
        },
      };
    } else {
      return {
        notFound: true,
      };
    }

    breadcrumb[breadcrumb?.length - 1] = {
      title: breadcrumb.at(-1)?.title || "",
      link: normalizedConference?.link || "",
    };
    breadcrumb.push({ title: locale === "fa" ? "ویدیوها" : "Videos" });

    return {
      props: {
        data: {
          latestNews: response?.[0] || [],
          conference: normalizedConference,
          conferences: normalizeHomeConferences(response[0], locale) || null,
          changeLanguageLink: targetVideo?.changeLanguageLink || "",
          breadcrumb: breadcrumb || [],
          metaTag: targetConference?.metaTag || {},
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default ConferenceVideosPage;
